// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2gNK7","info":"UpdateTermsInfo_info__xfBgV"};